import React from "react";

import IconBase, { IconBaseProps } from "./IconBase";

/**
 * Inflammation — 20×20 lab group icon (Figma 834:59).
 *
 * Six small arrow-like vector marks radiating outward. Each native
 * viewBox matches its allocated rectangle on the 20×20 parent, so each
 * group is just translated to its inset offset (no scaling).
 *
 * Layer offsets (Figma insets → translate on 20×20):
 *   • 834:18 — translate(7.42,  12.128)  (3.237 × 5.874)
 *   • 834:19 — translate(1.908,  9.98)   (6.612 × 3.226)
 *   • 834:20 — translate(3.838,  3.78)   (4.582 × 5.544)
 *   • 834:21 — translate(9.762,  2.218)  (3.607 × 5.592)
 *   • 834:22 — translate(12.02,  7.258)  (6.305 × 3.117)
 *   • 834:23 — translate(11.84, 10.592)  (4.331 × 5.228)
 */
const IconInflammation: React.FC<IconBaseProps> = ({
  size = 24,
  color = "currentColor",
  className = "",
  ...props
}) => {
  const iconSize =
    typeof size === "number" ? size : parseInt(size as string, 10) || 24;
  return (
    <IconBase
      size={iconSize}
      color={color}
      className={className}
      viewBox="0 0 20 20"
      {...props}
    >
      <g transform="translate(7.42 12.128)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.378488 5.8723C0.149363 5.85122 -0.0193036 5.64835 0.00177977 5.41918L0.336197 1.7873L2.02161 2.67893L2.40936 0.348346C2.44715 0.121346 2.66178 -0.0320706 2.88878 0.00572108C3.11578 0.0434711 3.26915 0.258096 3.2314 0.485096L2.65391 3.95618L1.0514 3.10843L0.831613 5.4956C0.81053 5.72476 0.607655 5.89343 0.378488 5.8723Z"
        />
      </g>
      <g transform="translate(1.908 9.98)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.0530168 2.41642C-0.0592416 2.21554 0.0126002 1.96167 0.213479 1.84942L3.52292 0L3.7515 1.98212L6.01942 0.923958C6.22796 0.826666 6.47587 0.916875 6.57321 1.12537C6.6705 1.33392 6.58029 1.58187 6.37179 1.67917L3.05613 3.22612L2.83829 1.33721L0.620004 2.57688C0.419125 2.68913 0.165275 2.61729 0.0530168 2.41642Z"
        />
      </g>
      <g transform="translate(3.838 3.78)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.0605316 0.200545C0.179927 0.00382009 0.436207 -0.0588632 0.632915 0.0605326L3.95237 2.0752L2.29512 3.28491L4.40687 4.78787C4.59437 4.92133 4.63816 5.1815 4.50475 5.36895C4.37133 5.55645 4.11116 5.60024 3.92366 5.46683L0.869957 3.29341L2.45146 2.13908L0.200544 0.772912C0.00382329 0.653537 -0.0588642 0.397245 0.0605316 0.200545Z"
        />
      </g>
      <g transform="translate(9.762 2.218)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.26248 0.0064007C3.48906 0.0463632 3.6404 0.262472 3.60044 0.489092L2.97427 4.04001L1.38981 3.02597L0.820729 5.27735C0.764312 5.50043 0.537729 5.6356 0.314646 5.57918C0.0915623 5.5228 -0.0436042 5.29622 0.0128124 5.07314L0.865271 1.70083L2.37069 2.66431L2.77977 0.344376C2.81973 0.117755 3.03585 -0.0335618 3.26248 0.0064007Z"
        />
      </g>
      <g transform="translate(12.02 7.258)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.2532 0.810875C6.36387 1.01267 6.29004 1.26592 6.08824 1.37658L2.91533 3.11696L2.7137 1.2385L0.589953 2.20904C0.380661 2.30467 0.133453 2.21254 0.0377864 2.00325C-0.0578386 1.79396 0.0342857 1.54675 0.243577 1.45108L3.41891 0L3.61054 1.78521L5.68749 0.645959C5.88924 0.535292 6.14254 0.609125 6.2532 0.810875Z"
        />
      </g>
      <g transform="translate(11.84 10.592)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.26997 5.02752C4.1506 5.22422 3.89431 5.28689 3.6976 5.16752L0.564975 3.26622L2.1136 2.13585L0.1751 0.756183C-0.0124002 0.622725 -0.0561917 0.362558 0.077225 0.1751C0.210683 -0.0124002 0.470808 -0.0561917 0.658308 0.077225L3.53877 2.12731L2.06589 3.20239L4.12998 4.45514C4.32668 4.57452 4.38939 4.83077 4.26997 5.02752Z"
        />
      </g>
    </IconBase>
  );
};

export default IconInflammation;
